import {
  OfferTemplate_Get as templates,
  OfferTemplate_GetKnownPromotions as promotions,
  OfferTemplate_GetKnownThemes as themes,
  OfferTemplate_GetKnownCountries as countries,
  OfferTemplate_GetById as byId,
  OfferTemplate_GetPromotions as allPromotions,
} from './backend'

const getOfferTemplates = async (page, pageSize, sortBy, filters) => {
  let {data} = await templates({
    sortBy: sortBy,
    page: page,
    pageSize: pageSize,
    fulltextSearch: filters.fulltextSearch,
    online: filters.online,
    offline: filters.offline,
  })
  return data
}

const getAllPromotions = async (page, pageSize, sortBy) => {
  let {data} = await allPromotions({
    sortBy: sortBy,
    page: page,
    pageSize: pageSize,
  })
  return data
}

const getCountries = async () => {
  let {data} = await countries()
  return data
}

const getThemes = async () => {
  let {data} = await themes()
  return data
}

const getPromotions = async () => {
  let {data} = await promotions()
  return data
}

const getById = async id => {
  let {data} = await byId({id: id})
  return data
}

export default {
  getOfferTemplates,
  getCountries,
  getThemes,
  getPromotions,
  getById,
  getAllPromotions,
}
